export default "__VITE_ASSET__EGOa3HSl__"